// Mode démo des pages playoffs (?demo dans l'URL) : résultats fictifs, avec les vraies équipes
// du classement, pour voir le tableau rempli avant / pendant les playoffs.
// Rencontres au meilleur des 5 parties (3-0, 3-1, 3-2...), en aller / retour.

export const isDemoMode = (search) => new URLSearchParams(search).has('demo');

// Rencontre au format de getPODMatchs.php (après regroupement des sets, cf. parseMatchs)
// score : [parties domicile, parties extérieur], null si la rencontre n'est pas encore jouée
const createMatch = (rencId, day, date, home, away, score) => ({
    renc_id: String(rencId),
    day_id: String(day),
    date,
    domicile: home?.title || '',
    exterieur: away?.title || '',
    clubnum_1: home?.identifier || '',
    clubnum_2: away?.identifier || '',
    home_points: score ? String(score[0]) : null,
    away_points: score ? String(score[1]) : null,
    winner: score ? (score[0] > score[1] ? 'home' : 'away') : null,
    sets_data: [],
});

// Tableau à 6 équipes (Pro A Dames, Pro B Messieurs) : seed(n) = club classé n-ième du tableau
// (1 à 6 en playoffs, 7 à 12 en playdowns). Scénario terminé, tous les matchs joués :
// - quarts : le 4e et le 3e se qualifient en gagnant leurs deux matchs ;
// - demi 1 : 1 victoire partout, le 4e passe au cumul des parties (5 à 4) ; demi 2 : le 2e gagne ses deux matchs ;
// - finale : le 4e gagne ses deux matchs ; places 3-4 : le 1er ; places 5-6 : le 6e, au cumul des parties.
// singleFinal : finale en rencontre unique (Pro A dames 2026-2027), gagnée 3-1 par le 4e
export const demoBracket6 = (seed, firstId = 900000, singleFinal = false) => {
    let id = firstId;
    const match = (day, date, home, away, score) => createMatch(id++, day, date, home, away, score);
    return [
        // Quarts de finale (J16 / J17)
        match(16, '10/04/2027', seed(5), seed(4), [2, 3]),
        match(17, '17/04/2027', seed(4), seed(5), [3, 1]),
        match(16, '10/04/2027', seed(3), seed(6), [3, 0]),
        match(17, '17/04/2027', seed(6), seed(3), [1, 3]),
        // Demi-finales (J18 / J19)
        match(18, '24/04/2027', seed(1), seed(4), [3, 2]),
        match(19, '01/05/2027', seed(4), seed(1), [3, 1]),
        match(18, '24/04/2027', seed(3), seed(2), [1, 3]),
        match(19, '01/05/2027', seed(2), seed(3), [3, 1]),
        // Places 5-6 : perdants des quarts
        match(18, '24/04/2027', seed(5), seed(6), [3, 2]),
        match(19, '01/05/2027', seed(6), seed(5), [3, 0]),
        // Finale (J20 / J21) : vainqueurs des demi-finales
        match(20, '08/05/2027', seed(4), seed(2), [3, 1]),
        ...(singleFinal ? [] : [match(21, '15/05/2027', seed(2), seed(4), [2, 3])]),
        // Places 3-4 : perdants des demi-finales
        match(20, '08/05/2027', seed(1), seed(3), [3, 0]),
        match(21, '15/05/2027', seed(3), seed(1), [3, 2]),
    ];
};

// Pro A Messieurs : demi-finales aller (J23) / retour (J24), finale sur un match (J25).
// Scénario terminé : le 1er et le 2e se qualifient, le 1er gagne la finale 3-2.
export const demoProA = (seed, firstId = 900000) => {
    let id = firstId;
    const match = (day, date, home, away, score) => createMatch(id++, day, date, home, away, score);
    return [
        match(23, '15/05/2027', seed(1), seed(4), [3, 1]),
        match(24, '22/05/2027', seed(4), seed(1), [2, 3]),
        match(23, '15/05/2027', seed(3), seed(2), [2, 3]),
        match(24, '22/05/2027', seed(2), seed(3), [3, 0]),
        match(25, '29/05/2027', seed(1), seed(2), [3, 2]),
    ];
};
